module.exports = __webpack_public_path__ + "static/media/abtbanshape.8e17cd99.png";